import FooterLogo from "./images/footer-logo.svg";

function CustomFooter() {
  const footerMenu = [
    { name: "About Us", link: "#" },
    { name: "Blog", link: "#" },
    { name: "Donate", link: "#" },
    { name: "Terms of Service", link: "#" },
    { name: "Privacy Policy", link: "#" },
    { name: "Help", link: "#" },
    { name: "Contact Us", link: "#" },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer class="site-footer footer">
      <div class="container">
        <div class="footer-top">
          <div class="left-col">
            <img src={FooterLogo} alt="footer-logo" />
          </div>
          <div class="footer-navs">
            <ul>
              {footerMenu.map((item, index) => (
                <li key={index}>
                  <a href={item.link}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div class="copyright-text">
          <p>
            Copyright © {currentYear} DRC Systems India Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default CustomFooter;
